
 <template>
    <el-dialog
      title="返优惠审批单详情"
      :visible.sync="visible"
      width="850px"
      @close="handleClose">
      <el-form ref="form" label-width="150px">
        <el-row class="form-title">基础信息</el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="返优惠审批单号">{{form.code}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="返优惠名称">{{form.name}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="返优惠产生规则名称">{{form.policyName}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="返优惠产生规则编码">{{form.policyCode}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="状态">{{form.statusName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="申请金额合计（元）">{{form.totalApplyAmount}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核金额（元）">{{form.totalAuditAmount}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="创建时间">{{form.createTime}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提交审核时间">{{form.applyVerifyTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="审核时间">{{form.verifyTime}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到期时间">{{form.expireTime}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="form-title">
        返优惠明细
        <el-button type="primary" @click="handleExport" class="export-btn" v-permission="'0230202'">导出</el-button>
      </el-row>
      <el-table border :data="detailTable" tooltip-effect="light">
        <el-table-column
          prop="customerName"
          label="客户名称"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="batch"
          label="批次"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="itemNames"
          label="商品名称"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="actualNum"
          label="运发量（t）"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="perTonRebate"
          label="每吨返优惠（元/t）"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="applyAmount"
          label="申请金额（元）"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="auditAmount"
          label="审核金额（元）"
          :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </div>
    </el-dialog>
  </template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'addOrEditDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: false,
      form: {},
      detailTable: [],
      total: 0,
      listState: {
        pageNo: 1,
        pageSize: 10
      }
    }
  },
  computed: {},
  mounted () {
    this.visible = true
    this.queryDetail()
    this.queryTable()
  },
  methods: {
    ...mapActions(['rebateAuditFormInfo', 'rebateAuditFormInfoList', 'exportAuditForm']),
    handleClose () {
      this.$emit('update:show', false)
    },
    queryDetail () {
      this.rebateAuditFormInfo({ id: this.info.id }).then(res => {
        if (res.success) {
          this.form = res.data
        }
      })
    },
    queryTable () {
      const params = {
        ...this.listState,
        rebateAuditFormId: this.info.id
      }
      this.rebateAuditFormInfoList(params).then(res => {
        if (res.success) {
          const { list = [], total, pageNum, pageSize } = res.data
          this.detailTable = list
          this.total = total
          this.listState.pageNo = pageNum
          this.listState.pageSize = pageSize
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.listState.pageSize = val
      this.queryTable()
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.queryTable()
    },
    // 导出
    handleExport () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          rebateAuditFormId: this.info.id,
          ...this.listState
        }
        this.exportAuditForm(params).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '返优惠明细.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        // this.form = this.isEdit ? { ...this.info } : this.$lodash.cloneDeep(this.baseForm)
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
  .el-input, .form-select, .el-input-number {
    width: 200px;
  }

  .img-upload {
    height: 148px;
  }
  .form-title {
    font-weight: bold;
    margin-bottom: 20px;
  }
  .export-btn{
    float: right;
  }
  </style>
